import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import { parseCsvLocalDateTime, parseEnumEmptyString } from '~/prix/utils/bulk/csvValueParsers'

const vaccineAdministration: Dataset = {
  schema: 'public_health',
  table: 'vaccine_administration',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    citizen_original_id: original => original,
    citizen_cpf: original => original,
    citizen_cns: original => original,
    health_unit_cnes: original => original,
    team_ine: original => original,
    professional_cbo: original => original,
    professional_cns: original => original,
    administration_date_time: original => parseCsvLocalDateTime(original as string),
    immunobiological_abbreviation: original => original,
    immunobiological_description: original => original,
    immunobiological_code: original => original,
    vaccination_strategy: original => parseEnumEmptyString(original as string),
    vaccine_dose_abbreviation: original => original,
    vaccine_dose_description: original => original,
    vaccine_batch: original => original,
    vaccine_manufacturer: original => original,
    attendance_group: original => original,
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default vaccineAdministration
